import React, { useEffect, useState } from "react";

const RootCause = ({rootCauses }) => {

  // Combine summaries
  const combinedSummary = (rootCauses || [])
    .map((item) => item.summary)
    .filter(Boolean) // removes null or empty
    .join("\n\n"); // separate by line breaks

  return (
    <div className="final-report-content mb-3">
      <h2 className="font-18 font-weight-bold heading-color mb-2">
        Root Cause Analysis:
      </h2>
      {combinedSummary ? (
        <p
          className="font-13 font-weight-normal text-color"
          dangerouslySetInnerHTML={{
            __html: combinedSummary.replace(/\n/g, "<br/>"),
          }}
        />
      ) : (
        <p className="font-13 font-weight-normal text-color">
          No root cause summaries available
        </p>
      )}
    </div>
  );
};

export default RootCause;
